export default __webpack_public_path__ + "static/media/footer-image.ca8f447b.svg";